import React from "react";
import OnboardingCard from "../../components/OnboardingComponents/OnboardingCard";

export const LoadingSkeletons = ({ viewMode }: { viewMode: "grid" | "list" }) => {
  if (viewMode === "grid") {
    return (
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
        {[...Array(8)].map((_, index) => (
          <OnboardingCard key={index} className="p-[30px]">
            <div className="animate-pulse">
              <div className="mb-5 flex items-center gap-4">
                <div className="h-[60px] w-[60px] rounded-[15.21px] bg-[#E5E7EB]" />
                <div className="flex-1">
                  <div className="mb-2 h-4 w-3/4 rounded bg-[#E5E7EB]" />
                  <div className="h-3 w-1/2 rounded bg-[#E5E7EB]" />
                </div>
              </div>
              <div className="mb-3 h-3 w-1/4 rounded bg-[#E5E7EB]" />
              <div className="mb-6 h-4 w-1/2 rounded bg-[#E5E7EB]" />
              <div className="h-[52px] w-full rounded-xl bg-[#E5E7EB]" />
            </div>
          </OnboardingCard>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      {[...Array(6)].map((_, index) => (
        <OnboardingCard key={index} className="p-6">
          <div className="animate-pulse flex items-center gap-6">
            <div className="h-12 w-12 rounded-[15.21px] bg-[#E5E7EB] shrink-0" />
            <div className="flex-1">
              <div className="mb-2 h-4 w-48 rounded bg-[#E5E7EB]" />
              <div className="h-3 w-64 rounded bg-[#E5E7EB]" />
            </div>
            <div className="h-4 w-32 rounded bg-[#E5E7EB]" />
            <div className="h-[52px] w-[180px] rounded-xl bg-[#E5E7EB]" />
          </div>
        </OnboardingCard>
      ))}
    </div>
  );
};